import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import formatTitle from "../common/formatTitle";
import Grid from "@material-ui/core/Grid";
import Img from "gatsby-image";
import Typography from "@material-ui/core/Typography";
import SquareBg from "./blue_block_mask.png";

const useStyles = makeStyles((theme) => ({
  regularRow: {
    padding: theme.layout.paddingRegular,
  },
  regularRowMobile: {
    padding: theme.layout.paddingRegularMobile,
  },
  blueBoxTitle: {
    fontSize: "1.5rem",
    fontWeight: "bolder",
  },
  blueBoxText: {
    fontSize: "1.1rem",
    minHeight: "80px",
  },
  blueBox: {
    borderRadius: 4,
    backgroundColor: "#1F3598",
    color: "#FFF",
    padding: `${theme.spacing(3)}px ${theme.spacing(4)}px`,
  },
  squareBg: {
    backgroundImage: `url(${SquareBg})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "20% 50%",
  },
  blueBoxItemSubtitle: {
    color: theme.palette.primary.light,
    fontSize: "1.1em",
    fontWeight: 600,
  },
  rounded: {
    borderRadius: 4,
  },
  enLight: {
    color: theme.palette.primary.light,
  },
  blueBoxTitle: {
    fontWeight: 600,
    color: "#FFF",
  },
  blueBoxParag: {
    maxWidth: "80%",
  },
  blueBoxHeading: {
    color: "#FFF",
    marginBottom: 0
  },
}));

const LargeScaleDeployment = ({ image, title, content, items }) => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("lg"));
  const matchesMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Grid
      item
      container
      direction="row"
      className={clsx({
        [classes.regularRow]: matches,
        [classes.regularRowMobile]: !matches,
      })}
      justify="center"
    >
      <Grid
        item
        container
        direction={matches ? "row" : "column-reverse"}
        className={clsx(classes.blueBox, classes.squareBg)}
        justify="space-between"
        alignItems="center"
        spacing={matches ? 0 : 2}
      >
        <Grid item xs={12} lg={7} container direction="column" spacing={3}>
          <Grid item>
            <Typography variant="h1" className={classes.blueBoxHeading}>
              {formatTitle(title)}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" className={classes.blueBoxParag}>
              {content}
            </Typography>
          </Grid>
          <Grid
            item
            container
            direcion="row"
            spacing={matches ? 4 : 2}
            justify="space-between"
          >
            {items.map((i, idx) => (
              <Grid item lg={6} xs={12} key={idx}>
                <Typography variant="h5" className={classes.blueBoxTitle}>
                  {i.title}
                </Typography>
                <Typography
                  variant="h6"
                  className={classes.blueBoxItemSubtitle}
                >
                  {i.subTitle}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Grid>
        {!matchesMobile && (<Grid item lg={5} xs={12} style={{ textAlign: "center" }}>
          <Img
            fixed={image}
            width={!matchesMobile ? 400 : "50%"}
            fadeIn
            className={classes.rounded}
          />
        </Grid>)}
      </Grid>
    </Grid>
  );
};

LargeScaleDeployment.defaultProps = {
  image: PropTypes.object.isRequired,
};

export default LargeScaleDeployment;
